import React from 'react';
import Swal from 'sweetalert2';
import './index.css';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) =>
    {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
    }
});

const showToast = (icon, title) =>
{
    Toast.fire({
        icon: icon,
        title: title
    });
};

export default showToast;